const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Admin Assignments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AdminAssignments', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v4/admin-assignments/:subresource/:type', null, {
    get: {params: {subresource: '',}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    search: {params: {subresource: 'search'}, method: 'post', isArray: true},
  });

}]);
